// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

export const SHOW_SPINNER = 'show_spinner'
export const SHOW_COMPONENT_SPINNER = 'show_component_spinner'

export const ON_SAVE = 'Saving'
export const ON_UPDATE = 'Updating data'
export const ON_FETCH = 'Refreshing'
export const ON_SEARCH = 'Searching'
export const ON_DELETE = 'Removing'

export function showSpinner (show) {
  return (dispatch) => {
    dispatch({
      type: SHOW_SPINNER,
      payload: show
    })
  }
}

export function showComponentSpinner (show, text = null) {
  return (dispatch) => {
    dispatch({
      type: SHOW_COMPONENT_SPINNER,
      payload: {
        showComponentSpinner: show,
        componentSpinnerText: text
      }
    })
  }
}
